export default __webpack_public_path__ + "static/images/platform3.256c547d.jpg";